import type { RendererState } from '@src/renderer/RendererState';
import type VideoCreatorStore from '@src/stores/VideoCreatorStore';

export interface StateChangeContext {
  /** True when the user is manually interacting with the renderer iframe
   *  (i.e. !isPlaying && isIframeActive). */
  isManualInteraction: boolean;
}

type HandlerSignature = ((
  videoCreator: VideoCreatorStore,
  newState: RendererState,
  context: StateChangeContext,
) => boolean) & { displayName: string };

export default class StateChangeObserver {
  constructor(private handlers: HandlerSignature[]) {
    this.handlers = handlers;
  }

  handle(
    videoCreator: VideoCreatorStore,
    newState: RendererState,
    context: StateChangeContext,
  ) {
    for (let i = 0; i < this.handlers.length; i++) {
      let shouldAbort: boolean;
      try {
        shouldAbort = this.handlers[i](videoCreator, newState, context);
      } catch (err) {
        console.error(
          `StateChangeObserver failed due to ${this.handlers[i].displayName} handler error`,
          err,
        );
        shouldAbort = true;
      }
      if (shouldAbort) {
        break;
      }
    }
  }
}
